<template>
  <div>
    <v-row class="checkbox ma-2">
      <p>{{ label }}</p>
      <v-col cols="auto" v-for="v of checkbox" :key="v"
        ><v-checkbox
          v-model="data.Records[0].json"
          :label="v"
          :value="v"
        ></v-checkbox> </v-col
    ></v-row>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    record: Object,
    init: String,
    label: String,
    //checkbox: Array,
    json: Array,
  },
  data() {
    return {
      data: {
        Page_id: 0,
        Report_id: null,
        Records: [{ value: "", form_id: 0, form_type: 14, json: [] }],
      },
      checkbox: [],
    };
  },
  async mounted() {
    //let tmp = "a,b,c";
    //console.log(JSON.stringify(this.data.Records[0].json));
    let tmp = "[" + this.init + "]";
    this.data.Records[0].json = JSON.parse(tmp);
    this.checkbox = this.json;
  },
};
</script>

<style></style>
